import React, { useEffect, useState, useCallback } from 'react';
import './Gallery.css';

function MirunaGallery() {
  const [activeItem, setActiveItem] = useState(null);

  const closeLightbox = useCallback(() => {
    setActiveItem(null);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    };
    if (activeItem) {
      document.addEventListener('keydown', onKeyDown);
      document.body.classList.add('lightbox-open');
    }
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.classList.remove('lightbox-open');
    };
  }, [activeItem, closeLightbox]);

  useEffect(() => {
    const imgContent = document.querySelectorAll('.img-content-hover');
    
    function showImgContent(e) {
      for (var i = 0; i < imgContent.length; i++) {
        const x = e.pageX;
        const y = e.pageY;
        imgContent[i].style.transform = `translate3d(${x}px, ${y}px, 0)`;
      }
    }

    document.addEventListener('mousemove', showImgContent);
    
    return () => {
      document.removeEventListener('mousemove', showImgContent);
    };
  }, []);

  const galleryItems = [
    { title: 'Drawing', category: 'Art', image: '/WebsitePhotos/MirunaSpineanu/Drawing10.jpg', size: 'md-4' },
    { title: 'Drawing', category: 'Art', image: '/WebsitePhotos/MirunaSpineanu/Drawing2.jpg', size: 'md-4' },
    { title: 'Drawing', category: 'Art', image: '/WebsitePhotos/MirunaSpineanu/Drawing4.jpg', size: 'md-4' },
    { title: 'Drawing', category: 'Art', image: '/WebsitePhotos/MirunaSpineanu/Drawing5.jpg', size: 'md-6' },
    { title: 'Magazine Design', category: 'Design', image: '/WebsitePhotos/MirunaSpineanu/magazine.png', size: 'md-6' },
    { title: 'Magazine Design', category: 'Design', image: '/WebsitePhotos/MirunaSpineanu/magazine2.png', size: 'md-4' },
    { title: 'Page Design', category: 'Design', image: '/WebsitePhotos/MirunaSpineanu/Pag2.png', size: 'md-4' },
    { title: 'T-shirt Mockup', category: 'Design', image: '/WebsitePhotos/MirunaSpineanu/T-shirt mockup 2.png', size: 'md-4' },
    { title: 'Website Design', category: 'Design', image: '/WebsitePhotos/MirunaSpineanu/website.png', size: 'xs-12' },
    { title: 'Canvas Art', category: 'Art', image: '/WebsitePhotos/MirunaSpineanu/Woven Emotions Canvas.png', size: 'md-6' },
  ];

  return (
    <section className="gallery">
      <div className="container">
        <div className="grid">
          {galleryItems.map((item, index) => (
            <div key={index} className={`column-xs-12 column-${item.size}`}>
              <figure
                className="img-container scroll-fade-in"
                onClick={() => setActiveItem(item)}
              >
                <img 
                  src={item.image}
                  alt={item.title}
                  className="img-placeholder"
                  style={{ objectFit: 'cover' }}
                />
                <figcaption className="img-content">
                  <h2 className="title">{item.title}</h2>
                  <h3 className="category">{item.category}</h3>
                </figcaption>
                <span className="img-content-hover">
                  <h2 className="title">{item.title}</h2>
                  <h3 className="category">{item.category}</h3>
                </span>
              </figure>
            </div>
          ))}
        </div>
      </div>
      {activeItem && (
        <div className="lightbox" onClick={closeLightbox}>
          <button
            className="lightbox__close"
            type="button"
            aria-label="Close"
            onClick={(e) => {
              e.stopPropagation();
              closeLightbox();
            }}
          >
            ×
          </button>
          <div
            className="lightbox__content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={activeItem.image}
              alt={activeItem.title}
              className="lightbox__image"
            />
            <div className="lightbox__actions">
              <a
                href={activeItem.image}
                download
                className="lightbox__download"
              >
                Download
              </a>
              <p className="lightbox__note">
                Artwork by Miruna Spineanu — please credit when shared.
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default MirunaGallery;





